import MainLayout from '@/app/layouts/MainLayout';
import { env } from '@/config/env';
import { ChangePasswordPage, LoginPage, ProtectedRoute } from '@/domains/auth';
import { SchedulePage } from '@/domains/calendar';
import { DashboardPage } from '@/domains/dashboard';
import { HelpPage } from '@/domains/help';
import { JobDetailPage, JobsPage } from '@/domains/jobs';
import { AreasPage, RegionsPage } from '@/domains/locations';
import PlannerPage from '@/domains/planner/pages/PlannerPage';
import {
  AuditTrailPage,
  CategoryTasksPage,
  DisciplinesPage,
  FormBuilderPage,
  FormListPage,
  JobCategoriesPage,
  JobManagementPage,
  JobTitlesPage,
  LeaveTypesPage,
  SettingsPage,
  SkillsPage,
  TaskTypesPage,
} from '@/domains/settings';
import { ShiftDetailPage, ShiftsPage } from '@/domains/shifts';
import { TeamDetailPage, TeamsPage } from '@/domains/teams';
import { TestCoveragePage } from '@/domains/test-coverage';
import {
  AddUserPage,
  LeaveCalendarPage,
  NewStartersPage,
  SkillsMatrixPage,
  UserDetailPage,
  UsersPage,
} from '@/domains/users';
import { OfflineBanner } from '@/shared/components';
import { Route, Routes } from 'react-router';

/**
 * AppRouter - Central route configuration
 *
 * Route structure:
 * - Protected routes: All routes under MainLayout
 * - Catch-all: 404 page
 */
export function AppRouter() {
  return (
    <>
      <OfflineBanner />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="jobs/:jobId" element={<JobDetailPage />} />
          <Route path="schedule" element={<SchedulePage />} />
          {/* Planner Route TODO: test and remove if not needed */}
          <Route path="planner" element={<PlannerPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/add" element={<AddUserPage />} />
          <Route path="users/skills-matrix" element={<SkillsMatrixPage />} />
          <Route path="users/new-starters" element={<NewStartersPage />} />
          <Route path="users/leave-calendar" element={<LeaveCalendarPage />} />
          <Route path="users/:userId" element={<UserDetailPage />} />
          <Route path="teams" element={<TeamsPage />} />
          <Route path="teams/:teamId" element={<TeamDetailPage />} />
          <Route path="shifts" element={<ShiftsPage />} />
          <Route path="shifts/:shiftId" element={<ShiftDetailPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="settings/job-management" element={<JobManagementPage />} />
          <Route path="settings/job-categories" element={<JobCategoriesPage />} />
          <Route path="settings/task-types" element={<TaskTypesPage />} />
          <Route path="settings/category-tasks" element={<CategoryTasksPage />} />
          <Route path="settings/form-builder" element={<FormListPage />} />
          <Route path="settings/form-builder/:id" element={<FormBuilderPage />} />
          <Route path="settings/job-titles" element={<JobTitlesPage />} />
          <Route path="settings/disciplines" element={<DisciplinesPage />} />
          <Route path="settings/skills" element={<SkillsPage />} />
          <Route path="settings/leave-types" element={<LeaveTypesPage />} />
          <Route path="settings/regions" element={<RegionsPage />} />
          <Route path="settings/areas" element={<AreasPage />} />
          <Route path="settings/audit-trail" element={<AuditTrailPage />} />
          <Route path="help" element={<HelpPage />} />
          {env.isDevelopment && <Route path="test-coverage" element={<TestCoveragePage />} />}
        </Route>
      </Routes>
    </>
  );
}
